module.exports = __webpack_public_path__ + "img/Slide27.bb3f5d7c.png";